
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevRating } from '@ds/components/Rating'
import { mapGetters } from 'vuex'

import { scrollToElement } from '@reviews/helpers'
import { trackClick } from '@tracking/events'

import translations from './RatingInfo.translations'

export default {
  components: {
    RevButtonBase,
    RevRating,
  },
  props: {
    ratings: {
      type: Object,
      required: true,
    },
    noLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      breakpoint: 'breakpoint',
    }),

    translations: () => translations,

    averageRate() {
      return this.ratings.averageRate
    },

    reviewsCount() {
      return this.ratings.reviewsCount
    },

    shouldDisplayRatings() {
      return this.reviewsCount > 0
    },
  },
  methods: {
    onRatingClick() {
      if (this.noLink) {
        return
      }

      trackClick({
        name: 'go_to_reviews',
        pageType: this.$route.name,
        value: this.ratings,
        zone: 'detail',
      })

      // We're differenciating the scroll behavior as we have a fixed header on desktop
      if (this.breakpoint <= 2) {
        this.scrollOnMobile()
      } else {
        this.scrollOnDesktop()
      }
    },

    scrollOnMobile() {
      /*
       * We have to use a getElementById instead of a ref as the target
       * anchor element is in another component
       */
      document.getElementById('reviews').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },

    scrollOnDesktop() {
      /*
       * We have to use a getElementById instead of a ref as the target
       * anchor element is used in another component and we prefer consistency
       * 164 = size of the header + spacings
       */
      scrollToElement(
        document.getElementById('reviews')?.getBoundingClientRect().top || 0,
      )
    },
  },
}
